const ApiRoutes = {
    CONTACT: '/api/contact',
    H_CAPTCHA_VERIFY: 'https://api.hcaptcha.com/siteverify',
} as const;

export default ApiRoutes;
